import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, isSignal, Signal } from '@angular/core';
import { IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { FilterSectionData } from './filter-section.directive';

@Component({
  selector: 'dojo-filters-panel-mobile-content',
  templateUrl: './filters-panel-mobile-content.component.html',
  styleUrl: './filters-panel-mobile-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, NgTemplateOutlet, IonHeader, IonTitle, IonToolbar, NgClass],
  host: { class: 'flex flex-col w-full modal-max-height' },
})
export class FiltersPanelMobileContentComponent {
  readonly titleLabel = input.required<string>();
  readonly filters = input.required<FilterSectionData[]>();

  // it's passed as a signal to keep it reactive
  // TODO: FE-2104 - it would be good to refactor dialog service
  // to easily update inputs (not send only once)
  readonly isSelectedInput = input<boolean | Signal<boolean>>(false);
  readonly clearAllLabelKey = input<string>('examdojo.clear_all');
  readonly onClearAllFn = input<() => void>();

  readonly hasMultipleSections = computed(() => this.filters().length > 1);

  readonly isSelected = computed(() => {
    const isSelected = this.isSelectedInput();
    return isSignal(isSelected) ? isSelected() : isSelected;
  });

  onClearAll(): void {
    this.onClearAllFn()?.();
  }
}
